import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_ACCOUNT_LIST = (params) => {
    return axiosIns.get(`/account?${params}`);
};

export const CREATE_ACCOUNT = (body) => {
    return axiosIns.post('/account', body);
};

export const DELETE_ACCOUNT = (id) => {
    return axiosIns.delete(`/account/${id}`);
};

export const UPDATE_ACCOUNT = (body) => {
    return axiosIns.put(`/account/${body.id}`, body.body);
};
export const GET_LIST_BOX_OPEX_REALIZATION = (planId, fundCenterId) => {
    return axiosIns.get(`/account/listbox-opex-realization/${planId}/${fundCenterId}`);
};
export const GET_LIST_BOX_OPEX_MONITORING = (planId, fundCenterId) => {
    return axiosIns.get(`/account/listbox-opex-monitoring/${planId}/${fundCenterId}`);
};
export const GET_LIST_BOX_CAPEX_REALIZATION = (planId, fundCenterId) => {
    return axiosIns.get(`/account/listbox-capex-realization/${planId}/${fundCenterId}`);
};
export const GET_LIST_BOX_CAPEX_MONITORING = (planId, fundCenterId) => {
    return axiosIns.get(`/account/listbox-capex-monitoring/${planId}/${fundCenterId}`);
};